const Theme = {
  body_background_color: '#fdf7ed',
  header_full_height: true,

  title_font: 'Montserrat',
  title_color: '#193E44',
  
  text_font: 'Montserrat',
  text_color: '#193E44',

  logo_image_url: 'patrimoineculturel.png',
  
  token_url: 'patrimoineculturel.svg',
  number_hidden: true,
  token_width: 50,

  title_margin: '10px',
  
  button_color: '#fce305',
  button_text_color: 'black',
  button_hover_text_color: 'black',
  button_hover_border_color: 'black',
  button_outlined_text_color: 'black',
  button_outlined_hover_text_color: 'black',
  button_radius: 100,
  button_border_width: 2,
}

export default Theme
// https://app.clickup.com/t/86dy0g8bz